import { CdpRadiusListResponse, CdpRadiusListResult } from "../app/shared/models/layout/cdp/radius/list/CdpRadiusList";


export function response(): CdpRadiusListResponse {
    return {
        cmd: {
            success: true,
            params: {
                count: results.length,
                result: results
            }
        }
    }
}


const results : CdpRadiusListResult[] = [{
    id: "string",
    imei: "string",
    imsi: "string",
    iccid: "string",
    msisdn: "string",
    mno: "string",
    packetTypeStr: "string",
    ts: "string",
    genEventTs: "string",
    genFramedIpAddress: "string",
    genAcctStatusType: 2,
    GenAcctInputGigaWords: 2,
    GenAcctOutputGigaWords: 2,
    GenAcctInputPackets: 2,
    GenAcctOutputPackets: 2,
    GenAcctTerminateCause: 2,
    GenAcctTerminateCauseStr: "string",
    GenAcctSessionTime: 2,
    GenCalledStationId: "string",
    GenCallingStationId: "string",
    GenSessionIdentifier: "string",
    GenNasIpAddress: "string",
    GenNasPort: 1,
    TgppImsi: "string",
    TgppChargingIdentifier: 1,
    TgppPdpType: 1,
    TgppQosProfile: "string",
    TgppRatRtpe: 1,
    TgppSgsnIpAddress: "string",
    TgppGgsnIpAddress: "string",
    TgppTimeZone: 3,
    TelitRequestDate: "string",
    TelitImeiSv: "string",
    TelitImeiReal: "string",
    TelitSgsnMcc: "string",
    TelitSgsnMccMnc: "string",
    TelitGgsnMcc: "string",
    TelitGgsnMccMnc: "string",
    TelitImsiMcc: "string",
    TelitImsiMccMnc: "string",
    TelitLocType: 3,
    TelitLocMcc: "string",
    TelitLocMnc: "string",
    TelitLocLac: 3,
    TelitLocCi: 4,
    TelitLocSac: 5,
    TelitLocRac: 65,
    TelitLocTac: 7,
    TelitLocEci: 8,
    TelitLocLat: 2,
    TelitLocLng: 8
}]
